import "core-js/modules/es6.number.is-integer.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/star-empty.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/star-full.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/star-half-white.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/star-half-dark.svg';
import MdmIcon from '~/components/atoms/Global/MdmIcon';
export default {
  name: 'RatingStars',
  components: {
    MdmIcon: MdmIcon
  },
  props: {
    rating: {
      type: Number,
      required: true
    },
    theme: {
      type: String,
      default: 'light'
    },
    size: {
      type: String,
      default: '12'
    }
  },
  computed: {
    enabledStarsCount: function enabledStarsCount() {
      return Math.floor(this.rating);
    },
    disabledStarsCount: function disabledStarsCount() {
      return 5 - Math.ceil(this.rating);
    },
    halfEnabledStar: function halfEnabledStar() {
      return !Number.isInteger(this.rating);
    }
  }
};